import * as React from 'react';

import * as styles from './styles.css';
import { EAppService } from '../../../types/appService';
import { AppsButtonList } from '../AppsButtonList';

interface IWebToAppBannerProps {
  onClick(appService: EAppService): void;
}

export function WebToAppBanner({ onClick }: IWebToAppBannerProps) {
  return (
    <div className={styles['container']} data-testid="WebToAppBanner">
      <div className={styles['img']} />
      <div className={styles['content']}>
        <span className={styles['title']}>В приложении — проще!</span>
        <span className={styles['subtitle']}>Скачайте где удобно</span>
        <AppsButtonList onDownloadAppClick={onClick} />
      </div>
    </div>
  );
}
